import {
  TOGGLE_YLOPO_OPT_IN_MODAL,
  SET_SIMILAR_LISTINGS,
  TOGGLE_FAVORITE_LISTING,
  APPEND_LISTINGS,
  SET_YLOPO_LISTINGS,
  SET_SEARCH_LISTINGS_TOTAL,
  SET_LISTING_SOURCE,
  TOGGLE_LISTING_SEARCH_MODAL,
  FETCH_HOMEBOT_LISTINGS_REQUEST,
  FETCH_HOMEBOT_LISTINGS_SUCCESS,
  FETCH_HOMEBOT_LISTINGS_FAILURE,
  FETCH_LISTING_REQUEST,
  FETCH_LISTING_SUCCESS,
  FETCH_LISTING_FAILURE,
} from 'src/actions/actionTypes'
import { LISTINGS_SEARCH } from 'src/constants/listings'

export const initialState = {
  showYlopoModal: false,
  ylopoUrl: undefined,
  listingsSource: null,
  searchListingsTotal: null,
  listings: {},
  listing: {
    address: {},
    roomsCounter: {},
    sqft: {},
    thumbnailImageFileNames: [],
  },
  similarListings: [],
  uiFlags: {
    showSearchModal: false,
  },
  loading: {
    [LISTINGS_SEARCH]: true,
  },
}

const listingsReducer = (state = initialState, { type, ...payload }) => {
  switch (type) {
    case TOGGLE_YLOPO_OPT_IN_MODAL:
      return {
        ...state,
        showYlopoModal: !state.showYlopoModal,
        ylopoUrl: payload.ylopoUrl,
      }
    case SET_SIMILAR_LISTINGS: {
      const { listings } = payload

      return {
        ...state,
        similarListings: listings,
      }
    }
    case TOGGLE_FAVORITE_LISTING: {
      const { listing, isFavorited, tag, position } = payload
      const listings = { ...state.listings }
      const insertPosition = position == null ? listings[tag].length : position

      if (isFavorited) {
        listings[tag] = [
          ...listings[tag].slice(0, insertPosition),
          listing,
          ...listings[tag].slice(insertPosition),
        ]
      } else {
        listings[tag] = listings[tag].filter(l => l.id !== listing.id)
      }

      return {
        ...state,
        listings: { ...listings },
      }
    }
    case SET_YLOPO_LISTINGS: {
      const { tag, listings } = payload

      return {
        ...state,
        listings: { ...state.listings, [tag]: listings },
        loading: {
          ...state.loading,
          [tag]: false,
        },
      }
    }
    case SET_SEARCH_LISTINGS_TOTAL: {
      return {
        ...state,
        searchListingsTotal: payload.total,
      }
    }
    case APPEND_LISTINGS: {
      const { tag, listings } = payload

      return {
        ...state,
        listings: {
          ...state.listings,
          [tag]: [...state.listings[tag], ...listings],
        },
        loading: {
          [tag]: false,
        },
      }
    }
    case SET_LISTING_SOURCE:
      return {
        ...state,
        listingsSource: payload.listingsSource,
      }
    case TOGGLE_LISTING_SEARCH_MODAL: {
      const { showSearchModal } = payload
      return {
        ...state,
        uiFlags: {
          ...state.uiFlags,
          showSearchModal,
        },
      }
    }
    case FETCH_HOMEBOT_LISTINGS_REQUEST: {
      const { tag, page } = payload

      const newListings = {
        ...state.listings,
      }

      if (page === 1) {
        newListings[tag] = []
      }

      return {
        ...state,
        listings: newListings,
        loading: {
          ...state.loading,
          [tag]: true,
        },
      }
    }
    case FETCH_HOMEBOT_LISTINGS_SUCCESS: {
      const { tag, listings, page } = payload

      let newListings = []

      if (page === 1) {
        newListings = {
          ...state.listings,
          [tag]: listings,
        }
      } else {
        newListings = {
          ...state.listings,
          [tag]: [...state.listings[tag], ...listings],
        }
      }

      return {
        ...state,
        listings: newListings,
        loading: {
          ...state.loading,
          [tag]: false,
        },
      }
    }
    case FETCH_HOMEBOT_LISTINGS_FAILURE: {
      const { tag } = payload

      return {
        ...state,
        listings: {
          ...state.listings,
          [tag]: [],
        },
        loading: {
          ...state.loading,
          [tag]: false,
        },
      }
    }

    case FETCH_LISTING_REQUEST: {
      const { listing } = state

      return {
        ...state,
        listing: {
          ...listing,
          loading: true,
        },
      }
    }
    case FETCH_LISTING_SUCCESS: {
      const { listing } = payload

      return {
        ...state,
        listing: { ...state.listing, ...listing, loading: false },
      }
    }
    case FETCH_LISTING_FAILURE: {
      return {
        ...state,
        listing: {
          loading: false,
        },
      }
    }
    default:
      return state
  }
}

export default listingsReducer
